export default "__VITE_ASSET__DGxCWc6D__"